<template>
    <div class="peribox">
        <div class="perititle">
            <div>Delivery Lead</div>
            <div class="periicons">
                <i class="far fa-sync-alt" @click="refresh"></i>
            </div>
        </div>
        <table class="peritable">
            <tbody>
            <tr>
                <th>Column</th>
                <th>Lead</th>
            </tr>
            <tr v-for="c in columns">
                <th>{{ c }}</th>
                <td>{{ row ? row[c] : '' }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'app_id',
        'delivery_lead_id'
    ],
    data() {
        let columns = [
            'id',
            'driver_id',
            'application_id',
            'application_job_id',
            'job_id',
            'employer_id',
            'date',
            'cost',
            'budget_hidden',
            'campaign_id',
            'referrer',
            'is_direct',
            'is_mc',
            'is_sc',
            'is_jobadviser',
            'is_exactmatch',
            'is_driverengage',
            'is_conversion',
            'is_call',
            'paid_media_source',
            'driver_engage_type',
            'agent_id',
            'app_type',
            'param1',
            'param2',
            'param3',
            'budget_period_id',
            'cdl_xp',
            'should_deliver',
            'budget_order_id'
        ];
        return {
            row: null,
            columns: columns
        };
    },
    methods: {
        refresh() {
            axios.get(url(`app/test/app/${this.app_id}/delivery/${this.delivery_lead_id}`))
                .then((response) => {
                    this.row = response.data.row;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>

<style>
</style>
